
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleetShowersPolartwilight as ObiLightningSleetShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningSleetShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet-showers-polartwilight',
   elementClass: ObiLightningSleetShowersPolartwilightElement,
   events: {
     
   }
  });
 
 